import { render, staticRenderFns } from "./TrendingAppItem.vue?vue&type=template&id=ef38c5f2"
import script from "./TrendingAppItem.vue?vue&type=script&lang=js"
export * from "./TrendingAppItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports